// File: store/viewNotFound.js
// Purpose: State store for the 404 view.
export default {
  header: "404 – Page Not Found",
  view: "ViewNotFound"
};
